// Проблемы записи условия; контракт общий у /predicate/convert и /search/query

/**
 * Вид проблемы записи условия.
 * Все виды, кроме `ConvertationError`, описывают саму запись; `ConvertationError` —
 * отказ языковой модели перевести описание в строгую форму.
 */
export type PredicateIssueType =
  | 'SyntaxError'
  | 'UnknownAttribute'
  | 'DeletedAttribute'
  | 'InvalidOperator'
  | 'TypeMismatch'
  | 'DeletedValue'
  | 'ConvertationError';

/**
 * Проблема, найденная в записи условия.
 */
export type PredicateIssue = {
  /** Вид проблемы */
  type: PredicateIssueType;
  /** Описание проблемы с сервера */
  message: string;
  /** Код атрибута, к которому относится проблема; у нарушения грамматики атрибута нет */
  attributeCode: string | null;
};

/** Отказ языковой модели — проблема обращения к ней, а не ошибка в записи условия. */
export const isModelIssue = (issue: PredicateIssue): boolean => issue.type === 'ConvertationError';

/** Проблемы самой записи условия — без отказов языковой модели. */
export const getRecordIssues = (issues: PredicateIssue[]): PredicateIssue[] => issues.filter((i) => !isModelIssue(i));
